<template>
    <div class="no-permission-page">
        <div class="no-permission-img">
            <img src="@/assets/images/access-denied.png" />
        </div>
        <div class="no-permission-content">
            <div class="no-permission-content-code">403</div>
            <div class="no-permission-content-text-header">
                Access Denied
            </div>
            <div class="no-permission-content-text">
                ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้<br>
                หากต้องการใช้งานหน้านี้ โปรดแจ้งถึงผู้ดูแลระบบของคุณ
            </div>
            <v-btn
                class="no-permission-content-btn"
                @click="$router.push({ name: 'Login' })"
                color="#d76436"
                dark>
                กลับหน้าเข้าสู่ระบบ
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoPermission'
}
</script>

<style lang="scss" scoped>
.no-permission-page {
    height: 100%;
    background-color: #f7f7f7;

    .no-permission-content {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-flow: column;
        margin-left: 13.3vw;
        z-index: 101;

        &-code {
            font-family: LexendDeca;
            font-size: 200px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: 20px;
            text-align: left;
            color: #430c08;
            margin-bottom: 50px;
        }

        &-text {
            font-family: Prompt;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.56;
            letter-spacing: normal;
            color: #6c6c6c;
            background-color: #f7f7f7ee;

            &-header {
                font-family: LexendDeca;
                font-size: 32px;
                line-height: 1.25;
                letter-spacing: normal;
                color: #000;
                margin-bottom: 16px;
                background-color: #f7f7f7ee;
            }
        }

        &-btn {
            width: 264px;
            height: 50px;
            margin-top: 39px;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 rgba(215, 100, 54, 0.26);
        }
    }
    .no-permission-img {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        z-index: 100;

        img {
            margin-right: 9vw;
        }
    }
}

::v-deep .no-permission-content-btn .v-btn__content {
    font-family: Prompt !important;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
}
</style>
